module.exports = {"title":"Central Settings","datatable":{"code":"Code","name":"Name"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/central_settings.php
// module id = j4J5
// module chunks = 86